import { Form, FormActions, Modal, type ModalOptions, TextInput, message } from 'ui';
import { useCreateFolderMutation } from '../queries';

export type CreateFolderModalOptions = {
  communityId?: string;
  parentId?: string;
  programId?: string;
};

type CreateFolderModalFormValues = {
  name: string;
};

type P = {
  onCancel: () => void;
  options: ModalOptions<CreateFolderModalOptions>;
};

const CreateFolderModal = ({ onCancel, options }: P) => {
  const { isPending: isLoadingCreateFolder, mutate: createFolder } = useCreateFolderMutation();

  const handleFormFinish = (values: CreateFolderModalFormValues) => {
    if (!options.isOpened) {
      return;
    }

    createFolder(
      {
        communityId: options.communityId,
        name: values.name,
        parentId: options.parentId,
        programId: options.programId,
      },
      {
        onSuccess() {
          message.success('Folder Successfully Created.');
          onCancel();
        },
      },
    );
  };

  return (
    <Modal isOpened={options.isOpened} onCancel={onCancel} title="Create Folder" width="medium">
      {options.isOpened ? (
        <Modal.HugContent>
          <Form<CreateFolderModalFormValues> onFinish={handleFormFinish}>
            <TextInput
              item={{
                label: 'Folder name',
                name: 'name',
                rules: [{ required: true, whitespace: true }],
              }}
            />
            <Modal.HugContent.Footer>
              <FormActions
                right={{ children: 'Cancel', onClick: onCancel }}
                submit={{ children: 'Save', loading: isLoadingCreateFolder }}
              />
            </Modal.HugContent.Footer>
          </Form>
        </Modal.HugContent>
      ) : null}
    </Modal>
  );
};

export default CreateFolderModal;
